const PersonalPara = `Hi there, I am a software developer by profession, currently working at Amdocs as part of a backend developement team. Feel free to contact me on below social media platforms.`;

export default PersonalPara;